exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".SideBarList__sideBarList_main___3vdTy .SideBarList__sidebarListItem___187GF.SideBarList__active___rgTxa{color:#fff!important;background-color:#f2755f!important;font-weight:700!important}", "", {"version":3,"sources":["/./src/layouts/src/layouts/CoreLayout/SideBarList.scss"],"names":[],"mappings":"AAAA,yGAGM,qBAAsB,mCACc,yBACR,CAC7B","file":"SideBarList.scss","sourcesContent":[".sideBarList_main {\n  .sidebarListItem {\n    &.active {\n      color: #fff !important;\n      background-color: #f2755f !important;\n      font-weight: bold !important;\n    }\n  }\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"sideBarList_main": "SideBarList__sideBarList_main___3vdTy",
	"sidebarListItem": "SideBarList__sidebarListItem___187GF",
	"active": "SideBarList__active___rgTxa"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap&modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./~/sass-loader?sourceMap!./src/layouts/CoreLayout/SideBarList.scss
// module id = 1199
// module chunks = 0